class PercentageFormatter {
  static formatValue(value: string): string {
    const decimalValue = parseFloat(value) * 100;
    const formattedValue = decimalValue.toFixed(2);
    return formattedValue;
  }
}

export default PercentageFormatter;
